import isSubtitleText from "./isSubtitleText";

const removeVersionSubtitles = (json: Record<string, any>) => ({
  ...json,
  elements: json.elements.filter((element: any) => !isSubtitleText(element.name))
});

export default removeVersionSubtitles;
